import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/internal/operators";
import { ApiRoutes } from "../../../config/api-routes";
import { LocationElement } from "../model/locationElement";
import { StructureSummary } from "../model/structureSummary.model";

@Injectable()
export class StructureService {
    constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}


    public getStructures(parentStructureId: number, type: string = '', ): Observable<StructureSummary[]> {
        let httpParams = new HttpParams()
        .set('ParentStructureId', parentStructureId?.toString())
        .set('Type', type);
        return this.httpClient
          .get<StructureSummary[]>(this.apiRoutes.BUILDING_STRUCTURES, { params: httpParams })
      }

    public getLocationElements(locationId: number): Observable<LocationElement[]>{
        return this.httpClient.get<LocationElement[]>(this.apiRoutes.getRouteWithInjectedParams(this.apiRoutes.BUILDING_STRUCTURES_ELEMENTS, [locationId.toString()]))
    }
}